import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/var/www/rehab-solution-front-end/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/var/www/rehab-solution-front-end/public/assets/doctor/Sufian.png");
;
import(/* webpackMode: "eager" */ "/var/www/rehab-solution-front-end/public/assets/Facebook-Cover.jpg");
;
import(/* webpackMode: "eager" */ "/var/www/rehab-solution-front-end/public/assets/image/about.jpg");
;
import(/* webpackMode: "eager" */ "/var/www/rehab-solution-front-end/public/assets/image/full-log.png");
;
import(/* webpackMode: "eager" */ "/var/www/rehab-solution-front-end/public/assets/image/logo.png");
;
import(/* webpackMode: "eager" */ "/var/www/rehab-solution-front-end/public/assets/image/service/1.jpg");
;
import(/* webpackMode: "eager" */ "/var/www/rehab-solution-front-end/public/assets/image/service/2.jpg");
;
import(/* webpackMode: "eager" */ "/var/www/rehab-solution-front-end/public/assets/image/service/3.jpg");
;
import(/* webpackMode: "eager" */ "/var/www/rehab-solution-front-end/public/assets/image/service/4.jpg");
;
import(/* webpackMode: "eager" */ "/var/www/rehab-solution-front-end/public/assets/image/service/5.jpg");
;
import(/* webpackMode: "eager" */ "/var/www/rehab-solution-front-end/public/assets/image/service/6.jpg");
;
import(/* webpackMode: "eager" */ "/var/www/rehab-solution-front-end/public/assets/image/tools/ex.jpg");
;
import(/* webpackMode: "eager" */ "/var/www/rehab-solution-front-end/public/assets/image/tools/ex1.jpg");
;
import(/* webpackMode: "eager" */ "/var/www/rehab-solution-front-end/public/assets/image/tools/ex2.jpg");
;
import(/* webpackMode: "eager" */ "/var/www/rehab-solution-front-end/public/assets/image/tools/ex3.jpg");
;
import(/* webpackMode: "eager" */ "/var/www/rehab-solution-front-end/public/assets/image/tools/ex4.jpg");
;
import(/* webpackMode: "eager" */ "/var/www/rehab-solution-front-end/public/assets/image/tools/ex5.jpg");
;
import(/* webpackMode: "eager" */ "/var/www/rehab-solution-front-end/public/assets/image/tools/ex6.jpg");
;
import(/* webpackMode: "eager" */ "/var/www/rehab-solution-front-end/public/assets/image/tools/ex7.jpg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/rehab-solution-front-end/src/app/appointment/appointment-form.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/rehab-solution-front-end/src/components/pages/home/services.tsx");
